import actions from 'redux/actions'
import { getState } from 'redux/core'
import { mixpanel, links, constants, getPrefixedAddressFields } from 'common/helpers'

import { setupBegin, setupCommit, setupBeginPayPal, setupCommitPayPal, callVindicia,
  syncUserAndSubscription, callAnalytics } from './util'


const begin = (values) => {
  const {
    models: {
      me: { gender: myGender, email: myEmail },
      requestTokens: { giftSubscription: giftSubscriptionToken },
    },
    view: {
      paymentPage: {
        coupon: { id: couponId, referralCoupon, isDisabled: isCouponDisabled },
      },
    },
  } = getState()
  const { giftSubscription, billing, paymentMethod } = values
  const { amount, monthCount, sendToDate, recipientGender, recipientEmail, recipientName, personalMessage } = giftSubscription
  const coupon = isCouponDisabled ? null : couponId

  const body = {
    ...getPrefixedAddressFields({ billing }),
    email: myEmail, // TODO @backend do we need this?
    gender: myGender, // TODO @backend do we need this?
    senderEmail: myEmail, // TODO @backend do we need this?
    paymentType: paymentMethod, // TODO ask backend rename `paymentType` to `paymentMethod`
    token: giftSubscriptionToken,
    giftGender: recipientGender, // TODO @backend do we need this?
    recipientName,
    recipientEmail,
    personalMessage,
    amount,
    plan: monthCount,
    coupon, // TODO @backend should use coupon from session
    referralCoupon,
  }

  if (sendToDate) {
    body.sendEmailDate = sendToDate
  }

  const begin = setupBegin({
    endpoint: 'rest/gift/subscription/begin',
    tokenName: constants.requestTokens.giftSubscription,
  })

  return begin(body)
}

/**
 *
 * @param {number} giftSubscriptionSession
 * @param {string} token
 */
const commit = setupCommit({
  endpoint: 'rest/gift/subscription/commit',
  tokenName: constants.requestTokens.giftSubscription,
})

/**
 *
 * @param {object} values
 * @param {object} values.giftSubscription
 * @param {number} values.giftSubscription.id
 * @param {number} values.giftSubscription.amount
 * @param {string} values.giftSubscription.sendBy
 * @param {string} values.giftSubscription.sendToDate
 * @param {string} values.giftSubscription.gender
 * @param {string} values.giftSubscription.email
 * @param {string} values.giftSubscription.name
 * @param {string} values.giftSubscription.message
 * @param {object} values.billing
 * @param {object} values.creditCard
 * @param {string} values.paymentMethod
 * @param {string} values.plan
 * @returns {*}
 */
const buyGiftSubscription = (values) => {
  const { giftSubscription, billing, creditCard, paymentType } = values

  mixpanel.track(constants.analyticsEvents.tech.buyGiftSubscription)

  return begin(values)
    .then(
      ({ giftSubscriptionSession, ...data }) => (
        callVindicia({
          paymentType,
          billing,
          creditCard,
          giftSubscription,
          giftSubscriptionSession,
          ...data,
        })
          .then(() => {
            const { models: { requestTokens: { giftSubscription: giftSubscriptionToken } } } = getState()

            return commit({
              giftSubscriptionSession,
              token: giftSubscriptionToken,
            })
          })
      ),
      (err) => Promise.reject(err)
    )
    .then(
      (result) => {
        syncUserAndSubscription({ paymentType, ...result })

        mixpanel.track(constants.analyticsEvents.paymentForm.placeOrder, {
          success: true,
        })
      },
      (err) => {
        const { title, message, resData: { isCvvError, authCode } = {} } = err

        const isBillingError = authCode === '713'

        actions.view.paymentPage.setBillingError(isBillingError)

        if (isCvvError) {
          actions.models.modals.open(constants.modals.ErrorCVV)
        }
        else {
          actions.models.modals.open(constants.modals.ServerError, {
            title,
            content: message,
          })
        }

        mixpanel.track(constants.analyticsEvents.paymentForm.placeOrder, {
          success: false,
          reason: `${authCode} | ${title} | ${message}`,
        })

        return Promise.reject(err)
      }
    )
    .then(() => {
      actions.view.paymentPage.setBillingError(false)
      callAnalytics()
      actions.models.router.push(links.thankYou)
    })
}


// PayPal

const beginGiftSubscriptionUsingPayPal = (values) => {
  const beginPayPal = setupBeginPayPal({
    begin,
    sessionName: 'giftSubscriptionSession',
  })

  return beginPayPal(values)
}

/**
 *
 * @param values
 * @param {string} values.paymentType
 * @param {string} values.paypalSessionId
 */
const commitGiftSubscriptionUsingPayPal = (values) => {
  const commitPayPal = setupCommitPayPal({
    commit,
    sessionName: 'giftSubscriptionSession',
  })

  return commitPayPal(values)
}


export {
  buyGiftSubscription,
  beginGiftSubscriptionUsingPayPal,
  commitGiftSubscriptionUsingPayPal,
}
